import script from "./ContextFormFieldsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextFormFieldsTab.vue?vue&type=script&setup=true&lang=js"

import "./ContextFormFieldsTab.vue?vue&type=style&index=0&id=95ff6064&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95ff6064"]])

export default __exports__